import styled from "styled-components";
import { Link } from "react-router-dom";

export const Navigation = styled.nav`
  background-color: ${({ theme }) => theme.color.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  box-shadow: 0 8px 28px rgba(21, 45, 26, 0.08);

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
   padding: 10px;
  }
`;

export const Logo = styled.img`
  height: 70px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    height: 46px;
  }
`;

export const Wrapper = styled.aside`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    gap: 8px;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 14px 16px 18px;
    max-height: calc(100vh - 100px);
    max-height: calc(100dvh - 100px);
    overflow-y: auto;
    overscroll-behavior: contain;
    z-index: 101;
    background-color: #fffcf5;
    border-bottom: 1px solid ${({ theme }) => theme.color.grey};
    box-shadow: 0 22px 45px rgba(21, 45, 26, 0.14);

    > a {
      width: min(100%, 520px);
      flex-shrink: 0;
    }
  }
`;

export const MenuLink = styled.a`
  margin: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  color: ${({ theme }) => theme.color.black};

  &:hover {
    color: ${({ theme }) => theme.color.orange};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    margin: 0;
    padding: 0 16px;
    border: 1px solid rgba(28, 93, 39, 0.14);
    border-radius: 13px;
    background: #fff;

    &::after { content: "→"; color: ${({ theme }) => theme.color.green}; }
  }
`;

export const NewLink = styled(Link)`
  margin: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  color: ${({ theme }) => theme.color.black};

  &:hover {
    color: ${({ theme }) => theme.color.orange};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    margin: 0;
    padding: 0 16px;
    border: 1px solid rgba(28, 93, 39, 0.14);
    border-radius: 13px;
    background: #fff;

    &::after { content: "→"; color: ${({ theme }) => theme.color.green}; }
  }
`;

export const Hamburger = styled.button`
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  padding: 8px;
  border: 0;
  border-radius: 12px;
  background: rgba(28, 93, 39, 0.08);
  cursor: pointer;

  img { width: 28px; }
`;

export const Button = styled(Link)`
  cursor: pointer;

  border-radius: 34px;
  background-color: ${({ theme }) => theme.color.green};
  border: none;
  color: ${({ theme }) => theme.color.white};
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  padding: 15px 40px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    min-height: 52px;
    margin-top: 2px;
    padding: 15px 24px;
  }
`;

